<template>
  <div class="phoneVerification">

    <div>
      <!-- <a-steps :current="current">
        <a-step v-for="item in steps" :key="item.title" :title="item.title" />
      </a-steps> -->
      
      <div class="steps-action">
        <!--  -->

          <div class="qrCode ">
           <h4 class="m-b-15">用户账号：12345678910</h4>
           <div class="width-150 height-150 base_bor">
               二维码
           </div>
           <p class="m-t-15 m-b-15">请用管理员微信扫描二维码进行验证</p>
          </div>
            <div @click="$router.push('/forgetpasswordtwo?account='+$route.query.account)" class="s_c376 s_shou" style="width:140px;margin: auto;background:#05486A;color:#fff;padding:5px;textAlign:center">重新选择验证方式</div>
      </div>
    </div>

  </div>
</template>
<script>
import { reactive, ref } from 'vue';
export default {
  setup() {
    const form = reactive({
      number: '1234*****910',
      code: '',
    });
    const current = ref(0);
    const steps = reactive([
      {
        title: '验证身份',
      },
      {
        title: '重置登录密码',
      },
      {
        title: '完成',
      },
    ]);
  
    const next = () => {
     
      current.value++;
    };
    const prev = () => {
      current.value--;
    };
    return {
      form,
      current,
      next,
      prev,
      steps,
    };
  },
};
</script>
<style lang="less" scoped>
.phoneVerification {
  width: 100%;
  background:#f8f8f8;
  padding: 30px;
  .bor_rad {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #fff;
    text-align: center;
    line-height: 40px;
  }
  .s_flex_center {
    flex-direction: column;
  }
  .bar {
    width: 220px;
    height: 5px;
    background: #fff;
  }
  .qrCode{
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  .base_bor{
    border: 1px solid #333;
  }
}
.ant-form-item {
  margin-bottom: 0px;
}
</style>